import { MYPAGE_HISTORY_REQUEST } from "constants/action-types";

export const fetchHistory = () => {
  const token = sessionStorage.getItem("token");

  return {
    type: MYPAGE_HISTORY_REQUEST,
    payload: {
      request: {
        url: "selling/my-page/history",
        method: "GET",
        headers: {
          'Cache-Control': 'no-cache',
          Authorization: `Bearer ${token}`
        }
      }
    }
  };
};



// WEBPACK FOOTER //
// ./src/actions/mypage/history.js